export const getRequestApprovalResponse = (response) => {
  const { data } = response;

  const totalData = data?.totalData;
  const totalPage = data?.totalPage;
  const isDataExist = data?.isDataExist;

  const reschedules = data?.reschedules?.map((item) => {
    return {
      ...item,
      hostName: item?.host?.name || '-',
      hostBrands: item?.host?.brands || '-',
      statusProgress: item?.statusProgress || '-',
      type: item?.type || '-',
      replacementSchedule: item?.replacementSchedule || '-',
      replacementHost: item?.replacementHost || '-',
      images: item?.images?.length ? item?.images?.map(({ name }) => name) : [],
      createdAt: item?.createdAt || '-',
      rawData: item,
    };
  });

  return { reschedules, totalData, totalPage, isDataExist };
};

export default getRequestApprovalResponse;
